import React, {PropTypes} from 'react'
import classNames from 'classnames'

import SidebarNavItem from './SidebarNavItem'
import './SidebarNavigation.less'

export default class SidebarNavigation extends React.Component {

  componentDidMount () {
    if (this.props.menuItems && !this.props.selectedItem) {
      this.handleClick(this.props.menuItems[0], [this.props.menuItems[0].id])
    }
  }

  handleClick = (menuItem, path) => {
    if (this.props.onItemChange === undefined) return
    let mi = menuItem
    while (mi.subMenu) {
      mi = mi.subMenu[0]
      path = path.concat(mi.id)
    }
    this.props.onItemChange(path, path[path.length - 1])
  }

  renderMenuItem (menuItem, parent, activePath) {
    let pathPos = activePath.indexOf(menuItem.id)
    let isSelected = pathPos > -1
    let miClasses = {
      'selected': isSelected,
      'selected-root': pathPos === 0,
      'selected-mid': pathPos > 0 && pathPos < activePath.length - 1,
      'selected-leaf': isSelected && pathPos === activePath.length - 1,
      [`${menuItem.className}`]: menuItem.className
    }
    let currPath = parent.concat(menuItem.id)
    let ItemComp = menuItem.component || SidebarNavItem
    return (
      <li key={menuItem.id} className={classNames(miClasses)}>
        <div onClick={() => { if (!isSelected) this.handleClick(menuItem, currPath) }}>
          <ItemComp label={menuItem.label} icon={menuItem.icon} level={currPath.length} />
        </div>
        { menuItem.subMenu && this.renderMenuTree(menuItem.subMenu, currPath, activePath, 'nmc-sbarnav-sub') }
      </li>
    )
  }

  renderMenuTree (menuItems, parent, activePath, cName) {
    return (
      <ul className={cName}>
        { menuItems && menuItems.map((menuItem) => this.renderMenuItem(menuItem, parent, activePath)) }
      </ul>
    )
  }

  render () {
    let sbarNavClasses = {
      'nmc-sbarnav': true,
      'disabled': this.props.disabled
    }
    let activePath = (this.props.selectedItem && this.props.selectedItem.path) || []
    return this.renderMenuTree(this.props.menuItems, [], activePath, classNames(sbarNavClasses))
  }
}

const MenuItem = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  icon: PropTypes.any,
  component: PropTypes.any,
  subMenu: PropTypes.arrayOf(PropTypes.shape(MenuItem))
}

const MenuItems = PropTypes.arrayOf(PropTypes.shape(MenuItem))

const SelectedItem = PropTypes.shape({
  path: PropTypes.arrayOf(PropTypes.string).isRequired
})

SidebarNavigation.propTypes = {
  menuItems: MenuItems,
  selectedItem: SelectedItem,
  onItemChange: PropTypes.func,
  disabled: PropTypes.bool
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/SidebarNavigation/SidebarNavigation.js